import { getFetcher } from '@/api/fetchers';
import { List } from '@/components/List/List';
import { TextHeader } from '@/components/List/Header/TextHeader';
import { Stack, Text, Loader } from '@mantine/core';
import { useParams } from 'react-router-dom';
import useSWR from 'swr';
import type {
  Price,
  Prices,
} from '@/schemas/API/GET/service/requestPriceHistory';
import { useState } from 'react';

const PriceDateCell = (item: Price) => (
  <Text key={`date-${item.effectiveDate}`}>
    {new Date(item.effectiveDate).toLocaleString('cs-CZ')}
  </Text>
);

const PriceAmountCell = (item: Price) => (
  <Text key={`price-${item.effectiveDate}`}>{item.price} Kč</Text>
);

export const PriceHistoryPage = (): JSX.Element => {
  const { serviceId } = useParams<{ serviceId: string }>();

  const { data: priceHistory, error: priceHistoryError } = useSWR<Prices>(
    serviceId ? `/services/${serviceId}/price-history` : null,
    getFetcher,
    {
      onSuccess: () => setIsLoading(false),
      onError: () => setIsLoading(false),
    }
  );

  const [isLoading, setIsLoading] = useState(false);

  if (isLoading) {
    return (
      <Stack className="h-full p-8 overflow-auto">
        <Loader size="sm" />
        <Text>Probíhá načítání dat...</Text>
      </Stack>
    );
  }

  if (priceHistoryError) {
    return (
      <Stack className="h-full p-8 overflow-auto">
        <Text c="red">
          Chyba při načítání historie cen. Nejsou žádné data.
        </Text>
      </Stack>
    );
  }

  if (!priceHistory || priceHistory.priceHistory.length === 0) {
    return (
      <Stack className="h-full p-8 overflow-auto">
        <Text>Nebyly nalezeny žádné záznamy historie cen.</Text>
      </Stack>
    );
  }

  return (
    <Stack className="h-full p-8 overflow-auto">
      <List
        columns={[
          <TextHeader key="effectiveDate" align="left">
            Datum
          </TextHeader>,
          <TextHeader key="price" align="left">
            Cena
          </TextHeader>,
        ]}
        content={{
          items: priceHistory?.priceHistory ?? [],
          renders: priceHistory
            ? [
                PriceDateCell,
                PriceAmountCell,
              ]
            : [],
        }}
      />
    </Stack>
  );
};

export {};
